export { getAnalytics } from "./analyticsWrapper";
export { type PageName } from "./IAnalytics";
